import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FileUploadS3 } from "../../../utils/FileUpload";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../../store/actions/User";
import Errors from "../../../constants/Errors.json";
import SuccessMessages from "../../../constants/SucessMessages.json";
import { FlexContainer } from "../../../constants/assets/containers";
import Upload from "sushiweb/Icons/all/Upload";
import variables from "../../../constants/assets/variables";

const MAX = 1048576;

const VideoUploader = (props) => {
  const {
    state,
    id,
    activeItem,
    presign_url,
    callback_key,
    uploadUrl,
    setStatus,
    setUploadedVideoName,
    videoKey,
    keyName,
    onError,
    disabled,
    maxSize,
    handleVideoChange,
    handleVideoClick,
    videoUrl,
    handleVideoUrlChange,
    noAckCall, //applicable when there is no need to hit ack api call
    acceptedFormats,
  } = props;

  const [activeUrl, setActiveUrl] = useState("");
  const [activeFile, setActiveFile] = useState("");

  const isClickFunctionDefined = () => {
    return handleVideoClick && typeof handleVideoClick === "function";
  };

  const handleChange = (e) => {
    e.preventDefault();
    if (isClickFunctionDefined()) {
      handleVideoClick();
      return;
    }
    const files = e.target.files;
    if (maxSize && files[0].size > maxSize * MAX) {
      setStatus({
        type: "error",
        message: "Please select file less than " + maxSize + " MB",
      });
      return;
    }
    handleVideoChange(files[0]);
    setActiveFile(files[0]);
    setUploadedVideoName(files[0].name);
    // this line right below will reset the
    // input field so if you removed it you can re-add the same file
    e.target.value = "";
  };

  useEffect(() => {
    if (callback_key && presign_url && activeFile) {
      FileUploadS3(
        callback_key,
        presign_url,
        activeFile,
        uploadUrl,
        keyName,
        noAckCall
      )
        .then((url) => {
          handleVideoUrlChange();
          setStatus({
            type: "success",
            message: SuccessMessages.FILE_UPLOAD_SUCCESS,
          });
        })
        .catch((err) => {
          if (onError) {
            if (typeof onError == "function") {
              onError(err);
              return;
            }
          }
          setStatus({
            type: "error",
            message: typeof err === "string" ? err : Errors.FILE_UPLOAD_FAILED,
          });
        });
    } else if (callback_key && presign_url && !activeFile) {
      setStatus({ type: "error", message: Errors.NO_FILE_SELECTED });
    }
  }, [callback_key, presign_url]);

  useEffect(() => {
    setActiveUrl(videoUrl);
  }, [videoUrl]);

  useEffect(() => {
    if (state === "Edit") {
      setActiveUrl(activeItem[videoKey]);
    }
  }, [state]);

  return (
    <VideoUpload id={id} url={activeUrl}>
      <VideoMask justify="center">
        {state === "Edit" ? (
          <Upload color={variables.white} />
        ) : (
          <Upload color={variables.white} />
        )}
      </VideoMask>
      <input
        type={isClickFunctionDefined() ? undefined : "file"}
        id="file-input"
        onChange={handleChange}
        onClick={isClickFunctionDefined() ? handleChange : undefined}
        accept={acceptedFormats ?? "video/mp4,video/m3u8"}
      />
    </VideoUpload>
  );
};

VideoUploader.defaultProps = {
  disabled: false,
  videoKey: "thumbnail",
};

const VideoUpload = styled.div`
  background-image: ${(props) => (props.url ? `url(${props.url})` : "unset")};
  width: 80px;
  margin-bottom: 30px;
  background-color: ${variables.black};
  background-size: contain;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.4);
  height: 5rem;
  opacity: 0.6;
  background-position: center;
  border-radius: 6px;
  background-repeat: no-repeat;
  #file-input {
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
`;

const VideoMask = styled(FlexContainer)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  img {
    width: 10rem;
    height: 10rem;
  }
`;

function mapDispatchToProps(dispatch) {
  return {
    setStatus: bindActionCreators(userActions.setStatus, dispatch),
    setUploadedVideoName: bindActionCreators(
      userActions.setUploadedVideoName,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(VideoUploader);
